import { Building2, ExternalLink } from 'lucide-react';
import type { EventPartner } from '@conference/shared';
import { apiAssetUrl } from '../../services/apiClient';

export default function PartnerCard({ partner, onOpen }: {
  partner: EventPartner;
  onOpen: (id: string) => void;
}) {
  return (
    <button
      onClick={() => onOpen(partner.id)}
      className="flex w-full items-center gap-3 rounded-xl border p-4 text-left active:opacity-80"
      style={{ background: 'var(--app-surface)', borderColor: 'var(--app-border)' }}
    >
      <div className="flex size-12 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white p-1">
        {partner.logo_url
          ? <img src={apiAssetUrl(partner.logo_url) ?? undefined} alt={partner.logo_alt_text ?? `${partner.display_name} logo`} className="size-full object-contain" />
          : <Building2 className="size-5" style={{ color: 'var(--app-accent)' }} />}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium" style={{ color: 'var(--app-text)' }}>{partner.display_name}</p>
        {partner.description && <p className="mt-1 line-clamp-2 text-xs" style={{ color: 'var(--app-text-muted)' }}>{partner.description}</p>}
      </div>
      {partner.website && <ExternalLink className="size-4 shrink-0" style={{ color: 'var(--app-text-subtle)' }} />}
    </button>
  );
}
